import { makeStyles, useTheme } from '@material-ui/core';
import classnames from 'classnames';
import PropTypes from 'prop-types';
import * as React from 'react';
const useStyles = makeStyles((theme) => ({
  root: {
    userSelect: 'none',
    width: '1em',
    height: '1em',
    display: 'inline-block',
    fill: 'currentColor',
    flexShrink: 0,
    transition: theme.transitions.create('fill', {
      duration: theme.transitions.duration.shorter,
    }),
  },
}));

function SvgPicEmptyNomintionPlan({ svgRef, ...props }) {
  const classes = useStyles();
  const theme = useTheme();
  const { color, className } = props;
  return (
    <svg
      {...props}
      viewBox="0 0 240 168"
      className={classnames(classes.root, className)}
      color={theme.colors[color] ?? color}
      ref={svgRef}
    >
      <defs>
        <filter
          x="-7.4%"
          y="-4.4%"
          width="114.7%"
          height="112.3%"
          filterUnits="objectBoundingBox"
          id="pic-empty-nomintion-plan_svg__a"
        >
          <feOffset dy={2} in="SourceAlpha" result="shadowOffsetOuter1" />
          <feGaussianBlur stdDeviation={2} in="shadowOffsetOuter1" result="shadowBlurOuter1" />
          <feColorMatrix
            values="0 0 0 0 0.2 0 0 0 0 0.207843137 0 0 0 0 0.196078431 0 0 0 0.08 0"
            in="shadowBlurOuter1"
          />
        </filter>
        <filter
          x="-7.4%"
          y="-4.4%"
          width="114.8%"
          height="112.3%"
          filterUnits="objectBoundingBox"
          id="pic-empty-nomintion-plan_svg__c"
        >
          <feOffset dy={2} in="SourceAlpha" result="shadowOffsetOuter1" />
          <feGaussianBlur stdDeviation={2} in="shadowOffsetOuter1" result="shadowBlurOuter1" />
          <feColorMatrix
            values="0 0 0 0 0.2 0 0 0 0 0.207843137 0 0 0 0 0.196078431 0 0 0 0.08 0"
            in="shadowBlurOuter1"
          />
        </filter>
        <rect id="pic-empty-nomintion-plan_svg__b" x={72} y={30} width={95} height={114} rx={3} />
        <path
          d="M3.255.435H91.68a3 3 0 013 3V111.07a3 3 0 01-3 3H3.255a3 3 0 01-3-3V3.435a3 3 0 013-3z"
          id="pic-empty-nomintion-plan_svg__d"
        />
      </defs>
      <g fill="none" fillRule="evenodd">
        <path
          d="M178.5 155c-40.206-9.933-77 7.5-102 7.5-40.5 0-79.079-37.6-70.5-79C14.025 44.768 72.454 47.801 108 28c109.5-61 112.5 22 126 64s-13 73.5-55.5 63z"
          fill="#E9EDFB"
        />
        <path
          d="M232.85 134.72l-.314.624C223.74 152.48 204 161.3 178.5 155c-40.205-9.933-77 7.5-102 7.5-30.12 0-59.177-20.796-68.564-48.486 24.958 11.645 58.255 13.5 111.564-3.514 62.31-19.886 93.764 2.8 113.35 24.22z"
          fill="#8F9DD6"
          opacity={0.32}
        />
        <g transform="rotate(-8 119.5 87)">
          <use
            fill="#000"
            filter="url(#pic-empty-nomintion-plan_svg__a)"
            xlinkHref="#pic-empty-nomintion-plan_svg__b"
          />
          <use fill="#FAFAFA" xlinkHref="#pic-empty-nomintion-plan_svg__b" />
        </g>
        <g transform="translate(77.07 26.2)">
          <use
            fill="#000"
            filter="url(#pic-empty-nomintion-plan_svg__c)"
            xlinkHref="#pic-empty-nomintion-plan_svg__d"
          />
          <use fill="#FFF" xlinkHref="#pic-empty-nomintion-plan_svg__d" />
        </g>
        <path
          fill="#E3E8E8"
          d="M86.028 37.993h32v5.229h-32zm0 20.559h23.871v5.229H86.028zm0-10.426h50v5.229h-50z"
        />
        <path
          fill="#F4F5FB"
          d="M148.618 36.413h17v16h-17zm.051 19.618h16.941v14h-16.941zm0 18h16.941v16.618h-16.941zm-20.941 0h16.941v16.618h-16.941zm-20.941 0h16.941v16.618h-16.941zm-20.942 0h16.941v16.618H85.845zm62.824 20.618h16.941v16.618h-16.941zm-20.941 0h16.941v16.618h-16.941zm-20.941 0h16.941v16.618h-16.941zm-20.942 0h16.941v16.618H85.845zm62.824 20.619h16.941v16.618h-16.941zm-20.941 0h16.941v16.618h-16.941zm-20.941 0h16.941v16.618h-16.941zm-20.942 0h16.941v16.618H85.845z"
        />
        <g transform="translate(143.26 76.221)">
          <circle fill="#4557A1" cx={15.956} cy={15.98} r={15.956} />
          <circle fill="#FFF" fillRule="nonzero" cx={16.084} cy={15.88} r={5.725} />
          <circle fill="#4557A1" cx={15.646} cy={47.302} r={2.587} />
          <path
            fill="#4557A1"
            d="M16.112 41.918l-5.041-8.61-5.04-8.612 9.977-.06 9.978-.06-4.937 8.671z"
          />
        </g>
      </g>
    </svg>
  );
}

SvgPicEmptyNomintionPlan.propTypes = {
  svgRef: PropTypes.any,
  className: PropTypes.string,
  color: PropTypes.string,
  fontSize: PropTypes.any,
};
SvgPicEmptyNomintionPlan.defaultProps = {
  svgRef: undefined,
  className: undefined,
  color: undefined,
  fontSize: 16,
};
const ForwardRef = React.forwardRef((props, ref) => (
  <SvgPicEmptyNomintionPlan svgRef={ref} {...props} />
));
export default ForwardRef;
